/**
 * ListEditor — tableau éditable (lignes = cartes responsives, colonnes configurées) pour les listes du rapport (adresses, comptes, animaux…).
 */
import { Plus, Trash2 } from "lucide-react";
import { inputCls } from "../../comptabilite/_shared";

export default function ListEditor({ table, rows, onChange, testId }) {
  const list = Array.isArray(rows) ? rows : [];
  const blank = () => Object.fromEntries(table.cols.map((c) => [c.key, ""]));
  const setCell = (i, key, v) => onChange(list.map((r, j) => (j === i ? { ...r, [key]: v } : r)));
  const remove = (i) => onChange(list.filter((_, j) => j !== i));
  return (
    <div className="space-y-2" data-testid={testId}>
      {list.length === 0 && <p className="text-xs text-slate-400 italic">Aucun élément.</p>}
      {list.map((row, i) => (
        <div key={i} className="relative border border-slate-200 rounded-xl p-3 pr-10 bg-slate-50/60 grid grid-cols-2 md:grid-cols-4 gap-2" data-testid={`${testId}-row-${i}`}>
          {table.cols.map((c) => (
            <label key={c.key} className={`block ${c.wide ? "col-span-2" : ""}`}>
              <span className="block text-[10px] font-semibold uppercase tracking-wide text-slate-500 mb-0.5">{c.label}</span>
              {c.type === "select" ? (
                <select value={row[c.key] ?? ""} onChange={(e) => setCell(i, c.key, e.target.value)} className={inputCls} data-testid={`${testId}-${i}-${c.key}`}>
                  <option value="">—</option>
                  {!c.options.includes(row[c.key]) && row[c.key] && <option value={row[c.key]}>{row[c.key]}</option>}
                  {c.options.map((o) => <option key={o} value={o}>{o}</option>)}
                </select>
              ) : (
                <input type={c.type === "date" ? "date" : "text"} value={row[c.key] ?? ""} onChange={(e) => setCell(i, c.key, e.target.value)} className={inputCls} data-testid={`${testId}-${i}-${c.key}`} />
              )}
            </label>
          ))}
          <button type="button" onClick={() => remove(i)} className="absolute top-2 right-2 p-1.5 rounded-lg text-slate-400 hover:text-rose-600 hover:bg-rose-50" title="Retirer" data-testid={`${testId}-remove-${i}`}>
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...list, blank()])} className="inline-flex items-center gap-1 text-xs font-semibold text-teal-700 hover:underline" data-testid={`${testId}-add`}>
        <Plus className="w-3.5 h-3.5" /> {table.addLabel || "Ajouter"}
      </button>
    </div>
  );
}
